import { Component } from "@angular/core";

@Component({
  selector: "group-invitation-listbox-empty",
  templateUrl: "./group-invitation-listbox-empty.component.html",
  styleUrls: ["./group-invitation-listbox-empty.component.scss"],
})
export class GroupInvitationListboxEmptyComponent {}
